<!--
 * @Description: 备忘录 修改
 * @Author: ZSC
 * @Date: 2023-05-09 11:00:48.154
 * @LastEditors: PF
 * @LastEditTime: 2023-05-12 10:51:35
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="70px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="bt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="类型" prop="lx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.lx" clearable filterable  :popper-append-to-body="false">
                <el-option v-for="item in bwllxData" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开始时间" prop="kssj">
              <el-date-picker v-model="ruleForm.kssj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="结束时间 " prop="jssj">
              <el-date-picker v-model="ruleForm.jssj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="nr">
              <el-input v-model="ruleForm.nr" type="textarea" :autosize="{minRows:8}" resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import {
  submitEditForm,
  closeWindow,
  loadData,
  loadSelect
} from '@/api/common.js'
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const bwllxData = ref()
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadSelect({
        url: '/api/v2/bangong/beiwanglu/beiwangluleixing',
        data: bwllxData
      })
      loadData({
        url: '/api/v2/bangong/beiwanglu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {}
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  // ruleForm.value.kkdwid = Array.isArray(ruleForm.value.kkdwid) ? ruleForm.value.kkdwid[ruleForm.value.kkdwid.length - 1] : ruleForm.value.kkdwid
  submitEditForm({
    url: '/api/v2/bangong/beiwanglu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
